import { useState, useEffect } from 'react';

export type ThemeMode = 'light' | 'dark' | 'system';

function getInitialTheme(): ThemeMode {
  if (typeof window !== 'undefined') {
    const savedTheme = localStorage.getItem('theme') as ThemeMode;
    if (savedTheme && ['light', 'dark', 'system'].includes(savedTheme)) {
      return savedTheme;
    }
  }
  return 'light';
}

function getSystemPreference(): boolean {
  // if (typeof window !== 'undefined' && window.matchMedia) {
  //   return window.matchMedia('(prefers-color-scheme: dark)').matches;
  // }
  return false;
}

export function useDarkMode() {
  const [mode, setModeState] = useState<ThemeMode>('system');
  const [isDarkMode, setIsDarkMode] = useState(false);

  const setMode = (newMode: ThemeMode) => {
    setModeState(newMode);
    if (typeof window !== 'undefined') {
      localStorage.setItem('theme', newMode);
    }
  };

  useEffect(() => {
    // Initialize theme on client side
    const initialTheme = getInitialTheme();
    setModeState(initialTheme);
    return undefined;
  }, []);

  useEffect(() => {
    const updateTheme = () => {
      let shouldBeDark = false;

      if (mode === 'dark') {
        shouldBeDark = true;
      } else if (mode === 'light') {
        shouldBeDark = false;
      } else if (mode === 'system') {
        shouldBeDark = getSystemPreference();
      }

      if (typeof document !== 'undefined') {
        if (shouldBeDark) {
          document.documentElement.classList.add('dark');
        } else {
          document.documentElement.classList.remove('dark');
        }
      }

      // Update isDarkMode state after DOM changes
      setIsDarkMode(shouldBeDark);
    };

    updateTheme();

    // Listen for system theme changes only if mode is 'system'
    if (mode === 'system' && typeof window !== 'undefined') {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      const handleChange = () => updateTheme();

      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    }

    return undefined;
  }, [mode]);

  return {
    mode, setMode, isDarkMode,
  };
}
